const commonReducer = (state = {}, action) => {
  switch (action.type) {
    case "MENU_TOGGLE":
      return Object.assign({}, state, {
        menuToggle: action.data,
      });
    case "CANCEL":
      return Object.assign({}, state, {
        alertCancel: action.data,
      });
    case "NOTIFICATIONCOUNT":
      return Object.assign({}, state, {
        NotificationCountNew: action.data,
      });
    case "REMARKCHANGE":
      return Object.assign({}, state, {
        remarkTextChange: action.data,
      });
    case "FAV_COMMON_SEARCH_OPEN":
      return Object.assign({}, state, {
        favoriteCommonSearch: action.data,
      });
    case "DOC_COMMON_SEARCH_OPEN":
      return Object.assign({}, state, {
        documentCommonSearch: action.data,
      });
    case "PEN_COMMON_SEARCH_OPEN":
      return Object.assign({}, state, {
        pendingCommonSearch: action.data,
      });
    case "NEWDOC_COMMON_SEARCH_OPEN":
      return Object.assign({}, state, {
        newDocumentCommonSearch: action.data,
      });
    case "REQ_COMMON_SEARCH_OPEN":
      return Object.assign({}, state, {
        requestCommonSearch: action.data,
      });
    case "ACTION_COMMON_SEARCH_OPEN":
      return Object.assign({}, state, {
        actionCommonSearch: action.data,
      });
    case "MASTER_CAT1_COMMON_SEARCH_OPEN":
      return Object.assign({}, state, {
        category1CommonSearch: action.data,
      });
    case "MASTER_CAT2_COMMON_SEARCH_OPEN":
      return Object.assign({}, state, {
        category2CommonSearch: action.data,
      });
    case "SETTINGS_LED_COMMON_SEARCH_OPEN":
      return Object.assign({}, state, {
        ledgerCommonSearch: action.data,
      });
    case "SETTINGS_NOT_COMMON_SEARCH_OPEN":
      return Object.assign({}, state, {
        notificationCommonSearch: action.data,
      });
    case "FAV_COMMON_SEARCH_RESULT":
      return Object.assign({}, state, {
        favoriteCommonSearchResult: action.data,
      });
    case "DOC_COMMON_SEARCH_RESULT":
      return Object.assign({}, state, {
        documentCommonSearchResult: action.data,
      });
    case "PEN_COMMON_SEARCH_RESULT":
      return Object.assign({}, state, {
        pendingCommonSearchResult: action.data,
      });
    case "NEWDOC_COMMON_SEARCH_RESULT":
      return Object.assign({}, state, {
        newDocumentCommonSearchResult: action.data,
      });
    case "REQ_COMMON_SEARCH_RESULT":
      return Object.assign({}, state, {
        requestCommonSearchResult: action.data,
      });
    case "ACTION_COMMON_SEARCH_RESULT":
      return Object.assign({}, state, {
        actionCommonSearchResult: action.data,
      });
    case "MASTER_CAT1_COMMON_SEARCH_RESULT":
      return Object.assign({}, state, {
        category1CommonSearchResult: action.data,
      });
    case "MASTER_CAT2_COMMON_SEARCH_RESULT":
      return Object.assign({}, state, {
        category2CommonSearchResult: action.data,
      });
    case "SETTINGS_LED_COMMON_SEARCH_RESULT":
      return Object.assign({}, state, {
        ledgerCommonSearchResult: action.data,
      });
    case "SETTINGS_NOT_COMMON_SEARCH_RESULT":
      return Object.assign({}, state, {
        notificationCommonSearchResult: action.data,
      });
    case "Category1List":
      return Object.assign({}, state, {
        Category1List: action.data,
      });
    case "Category2List":
      return Object.assign({}, state, {
        Category2List: action.data,
      });
    case "CheckerList":
      return Object.assign({}, state, {
        CheckerList: action.data,
      });
    case "ApproverList":
      return Object.assign({}, state, {
        ApproverList: action.data,
      });
    case "ConsultantList":
      return Object.assign({}, state, {
        ConsultantList: action.data,
      });

    default:
      return state;
  }
};

export default commonReducer;
